module.exports = __webpack_public_path__ + "media/images/dashboard_icons/tips-c5178cea4268937d46250a9f86668f74.svg";